import type { FC } from "react";

import { Typography } from "@ui/components/Typography";

import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { Button } from "@jti/core-components/components/Button";
import { ImageBehaviour } from "@jti/core-components/components/ImageBehaviour";

import styles from "./Tile.module.scss";

type ContentProps = {
  img?: string;
  title?: string;
  text?: string;
};

export type TileProps = {
  title?: string;
  href?: string;
  ctaText?: string;
  content: ContentProps[];
};

export const Tile: FC<TileProps> = ({ title, ctaText, href, content }) => {
  return (
    <div className={styles.wrapper}>
      {title && (
        <Typography variant="h2" className={styles.title}>
          {title}
        </Typography>
      )}
      <div className={styles.container}>
        {content.map(({ img, title, text }, index) => (
          <div key={index} className={styles.contentWrapper} data-testid="tileContent">
            {img && (
              <div className={styles.imageContainer}>
                <ImageBehaviour src={img} alt={title} className={styles.imageWrapper} />
              </div>
            )}
            {title && <p className={styles.contentTitle}>{title}</p>}
            {text && <p className={styles.contentText}>{text}</p>}
          </div>
        ))}
      </div>
      {ctaText && href && (
        <Button href={href} variant="text-muted" type="button" iconAfter={LongArrowForwardIcon}>
          {ctaText}
        </Button>
      )}
    </div>
  );
};
